/**
 * KBG v2 — Series: tab panels + mobile product swiper
 */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 749px)';

  function qsa(root, sel) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  function mobileMq() {
    return window.matchMedia(MOBILE_MQ);
  }

  function destroySwiper(el) {
    if (el && el.swiper && typeof el.swiper.destroy === 'function') {
      el.swiper.destroy(true, true);
    }
    restoreSlideTabStops(el);
  }

  function restoreSlideTabStops(el) {
    if (!el) return;
    el.removeAttribute('aria-roledescription');
    qsa(el, '.swiper-slide').forEach(function (slideEl) {
      slideEl.removeAttribute('aria-hidden');
      slideEl.removeAttribute('aria-label');
      slideEl.removeAttribute('aria-roledescription');
      slideEl.setAttribute('role', 'listitem');
      qsa(slideEl, 'a, button').forEach(function (node) {
        if (node.getAttribute('tabindex') === '-1') node.removeAttribute('tabindex');
      });
    });
  }

  function syncSlideTabStops(swiper) {
    if (!swiper || !swiper.slides) return;
    Array.from(swiper.slides).forEach(function (slideEl) {
      var visible =
        slideEl.classList.contains('swiper-slide-visible') ||
        slideEl.classList.contains('swiper-slide-fully-visible') ||
        slideEl.classList.contains('swiper-slide-active');
      var links = qsa(slideEl, 'a, button');
      if (visible) {
        slideEl.removeAttribute('aria-hidden');
        links.forEach(function (node) {
          if (node.getAttribute('tabindex') === '-1') node.removeAttribute('tabindex');
        });
      } else {
        slideEl.setAttribute('aria-hidden', 'true');
        links.forEach(function (node) {
          node.setAttribute('tabindex', '-1');
        });
      }
    });
  }

  function isActivePanelSwiper(el) {
    var panel = el && el.closest('[data-kbg-series-panel]');
    return !panel || panel.getAttribute('data-active') === 'true';
  }

  function createSwiper(el) {
    if (!el || typeof Swiper === 'undefined' || el.swiper) return;
    var slides = el.querySelectorAll('.swiper-slide').length;
    if (slides < 2) return;
    var paginationEl = el.querySelector('.swiper-pagination');
    var reduceMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 12,
      watchOverflow: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      grabCursor: true,
      preventClicks: false,
      preventClicksPropagation: false,
      speed: reduceMotion ? 0 : 400,
      a11y: {
        enabled: true,
        paginationBulletMessage: 'Go to product {{index}}',
        containerRoleDescriptionMessage: 'carousel',
        itemRoleDescriptionMessage: 'slide',
        slideLabelMessage: 'Product {{index}} of {{slidesLength}}',
      },
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
            renderBullet: function (index, className) {
              return (
                '<button type="button" class="' +
                className +
                '" aria-label="Go to product ' +
                (index + 1) +
                '"></button>'
              );
            },
          }
        : undefined,
      on: {
        init: function () {
          syncSlideTabStops(this);
        },
        slideChange: function () {
          syncSlideTabStops(this);
        },
        transitionEnd: function () {
          syncSlideTabStops(this);
        },
      },
    });
  }

  function syncSwipers(root) {
    var isMobile = mobileMq().matches;
    qsa(root || document, '[data-kbg-series-swiper]').forEach(function (el) {
      if (isMobile && isActivePanelSwiper(el)) createSwiper(el);
      else destroySwiper(el);
    });
  }

  function updatePanelSwiper(panel) {
    if (!panel || !mobileMq().matches) return;
    var el = panel.querySelector('[data-kbg-series-swiper]');
    if (!el) return;
    if (el.swiper) {
      el.swiper.update();
      el.swiper.slideTo(0, 0);
    } else {
      createSwiper(el);
    }
  }

  function whenSwiperReady(cb) {
    if (typeof Swiper !== 'undefined') {
      cb();
      return;
    }
    window.addEventListener('load', function () {
      if (typeof Swiper !== 'undefined') cb();
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-kbg-series-tab]');
    if (!tab) return;
    var section = tab.closest('[data-kbg-series]');
    if (!section) return;
    var id = tab.getAttribute('data-kbg-series-tab');
    qsa(section, '[data-kbg-series-tab]').forEach(function (t) {
      var selected = t === tab;
      t.setAttribute('aria-selected', selected ? 'true' : 'false');
      t.setAttribute('tabindex', selected ? '0' : '-1');
    });
    qsa(section, '[data-kbg-series-panel]').forEach(function (p) {
      var active = p.getAttribute('data-kbg-series-panel') === id;
      p.setAttribute('data-active', active ? 'true' : 'false');
      if (active) {
        p.removeAttribute('hidden');
        p.removeAttribute('inert');
        updatePanelSwiper(p);
      } else {
        p.setAttribute('hidden', '');
        p.setAttribute('inert', '');
        var idle = p.querySelector('[data-kbg-series-swiper]');
        if (idle) destroySwiper(idle);
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('[data-kbg-series-tab]');
    if (!tab) return;
    var section = tab.closest('[data-kbg-series]');
    if (!section) return;
    var tabs = qsa(section, '[data-kbg-series-tab]');
    var current = tabs.indexOf(tab);
    if (current === -1) return;

    var nextIndex = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      nextIndex = (current + 1) % tabs.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      nextIndex = (current - 1 + tabs.length) % tabs.length;
    } else if (e.key === 'Home') {
      nextIndex = 0;
    } else if (e.key === 'End') {
      nextIndex = tabs.length - 1;
    } else {
      return;
    }

    e.preventDefault();
    tabs[nextIndex].click();
    tabs[nextIndex].focus();
  });

  function init() {
    whenSwiperReady(function () {
      syncSwipers(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var mq = mobileMq();
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', function () {
      syncSwipers(document);
    });
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(function () {
      syncSwipers(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    whenSwiperReady(function () {
      syncSwipers(event.target);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    qsa(event.target, '[data-kbg-series-swiper]').forEach(destroySwiper);
  });
})();
